import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initState = () => ({
  error: null,
  isLoading: false,
  profile: null,
  token: '',
});

export default {
  state: initState(),
  getters,
  mutations,
  actions,
};
